export default __webpack_public_path__ + "static/image5-3b5d2c015394e7c19edd39087e9d1801.jpeg";